/** Blizzard interface icons (Wowhead CDN dumps) served from public/wow/icons. */
export const WOW_ICONS = {
  resurrection: "/wow/icons/spell_holy_resurrection.jpg",
  guardianSpirit: "/wow/icons/spell_holy_guardianspirit.jpg",
  spyglass: "/wow/icons/inv_misc_spyglass_03.jpg",
  book: "/wow/icons/inv_misc_book_09.jpg",
  letter: "/wow/icons/inv_letter_15.jpg",
  coin: "/wow/icons/inv_misc_coin_01.jpg",
  map: "/wow/icons/inv_misc_map_01.jpg",
  scroll: "/wow/icons/inv_scroll_11.jpg",
  hearthstone: "/wow/icons/inv_misc_rune_01.jpg",
  achievement: "/wow/icons/achievement_general.jpg",
} as const;

export type WowIcon = (typeof WOW_ICONS)[keyof typeof WOW_ICONS];
